<div style="padding:10px;">
    <div class="sp-font-size-16 Inter-Medium sp-top-margin-10 sp-bottom-margin-10">JSON/Excel format for
        generating E-invoice</div>
    <div *ngIf="data?.isPreferenceAvailable">
        <div class="Inter-Regular sp-font-size-14 sp-bottom-margin-15">Select the file type you want to download
        </div>
        <div>
            <mat-form-field style="width:40vh">
                <mat-label>Choose One From Options</mat-label>
                <mat-select name="eInvoiceType" [(ngModel)]="fileTypeModel" required>
                    <mat-option *ngFor="let file of fileTypes" [value]="file">
                        {{file.value}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div style="display: flex;
    flex-direction: row-reverse; margin-top:20px;">
            <button class="download-btn sp-right-margin-10" [disabled]="!(fileTypeModel)" mat-raised-button
                (click)="download()">
                Download
            </button>
            <button class="cancel-btn sp-right-margin-10" mat-raised-button (click)="cancel()">
                Cancel
            </button>
        </div>
    </div>
    <div *ngIf="!data?.isPreferenceAvailable">
        <div class="Inter-Regular sp-font-size-14">You don’t have any documents to download, this could be because
            you haven’t requested for the file.
            In case you want to generate these, please drop an email to <span
                style="color:#004FFA; text-decoration: underline;">cs@solvezy.com</span>
        </div>
        <div style="margin-top: 20px;
        display: flex;
        direction: rtl;">
            <button class="cancel-btn sp-right-margin-10" mat-raised-button (click)="okay()">
                Okay
            </button>
        </div>
    </div>
</div>